import { HERO_IMAGE } from "@/data/dholera";

const U = (id) =>
  `https://images.unsplash.com/${id}?auto=format&fit=crop&w=1200&q=70`;

export const PARCEL_EXTRAS = {
  "parcel-01": {
    plotCode: "P-01",
    overview:
      "A residential plot inside the Activation Area where trunk utilities are already live at the boundary — power, water and ICT ducts. Walking distance to the planned neighbourhood centre and four minutes from the expressway interchange.",
    gallery: [
      U("photo-1600585154340-be6161a56a0c"),
      U("photo-1512917774080-9991f1c4c750"),
    ],
  },
  "parcel-02": {
    plotCode: "P-02",
    overview:
      "High-street commercial frontage on the Linear Zone's 70 m spine, zoned for mixed-use retail and office. The metro alignment runs two plots north, making this the corridor's most visible retail address.",
    gallery: [
      U("photo-1449157291145-7efd050a4d0e"),
      U("photo-1497366216548-37526070297c"),
    ],
  },
  "parcel-03": {
    plotCode: "P-03",
    overview:
      "Industrial parcel two rows from the semiconductor fab cluster. 33 kV power at the boundary, heavy-vehicle access road, and eligible for DSIRDA's early-bird industrial incentive window.",
    gallery: [
      U("photo-1486406146926-c627a92ad1ab"),
      U("photo-1500382017468-9049fed747ef"),
    ],
  },
  "parcel-04": {
    plotCode: "P-04",
    overview:
      "Canal-facing residential plot in TP 3 with a 12 m green buffer across the road. A quiet sector with the planned school block opposite — and the lowest entry ticket in the current index.",
    gallery: [
      U("photo-1512917774080-9991f1c4c750"),
      U("photo-1600585154340-be6161a56a0c"),
    ],
  },
  "parcel-05": {
    plotCode: "P-05",
    overview:
      "The closest commercial parcel to the airport boundary in this release — four kilometres from the terminal. Suited to hospitality, logistics offices or an aviation-services hub.",
    gallery: [
      U("photo-1449157291145-7efd050a4d0e"),
      U("photo-1545324418-cc1a3fa10c00"),
    ],
  },
  "parcel-06": {
    plotCode: "P-06",
    overview:
      "A 6,500 sq yd industrial reserve — the largest single parcel in the index. The solar park's evacuation corridor nearby keeps long-term power tariffs favourable for energy-intensive tenants.",
    gallery: [U("photo-1500382017468-9049fed747ef"), HERO_IMAGE],
  },
  "parcel-07": {
    plotCode: "SY-16",
    overview:
      "Survey No. 16, Kamaatlav village — a plan-passed, NA-ready residential plot just 4 km from the Dholera International Airport. Fronts a 180-foot arterial road, making it a prime handover-ready ticket in the airport belt. Total area 6,910 Gaj (sq yd) at ₹8,500 per Gaj.",
    gallery: [
      U("photo-1600585154340-be6161a56a0c"),
      U("photo-1512917774080-9991f1c4c750"),
    ],
  },
  "parcel-08": {
    plotCode: "SY-586",
    overview:
      "Survey No. 586, Sandhida village — a large industrial parcel inside the SIR on the industrial linear corridor. Title clear and NA ready, with 180-foot road frontage for heavy-vehicle access. Total area 28,548 Gaj (sq yd) at ₹15,000 per Gaj.",
    gallery: [
      U("photo-1486406146926-c627a92ad1ab"),
      U("photo-1500382017468-9049fed747ef"),
    ],
  },
  "parcel-09": {
    plotCode: "SY-312/7",
    overview:
      "Survey No. 312/7, Bavliyari — a title-clear, NA-ready residential plot in the SIR core with 180-foot road frontage. Total area 4,840 Gaj (sq yd) at ₹9,000 per Gaj — a compact, shovel-ready entry parcel.",
    gallery: [
      U("photo-1613977257363-707ba9348227"),
      U("photo-1600585154340-be6161a56a0c"),
    ],
  },
  "parcel-10": {
    plotCode: "SY-305",
    overview:
      "Survey No. 305, Bavliyari — a title-clear, NA-ready residential holding of 24,200 Gaj (sq yd) with 180-foot road frontage in the SIR core. Priced at ₹9,000 per Gaj, ideal for a plotted development or long-hold land bank.",
    gallery: [
      U("photo-1512917774080-9991f1c4c750"),
      U("photo-1613977257363-707ba9348227"),
    ],
  },
  "parcel-11": {
    plotCode: "SY-305/P",
    overview:
      "Survey No. 305/P — a 26-Bigha (~65,000 sq yd) farmland parcel with 180-foot road frontage, NA application currently in process. Headline price ₹85 Lakh per Bigha (≈ ₹3,400 per sq yd) — the largest and lowest per-yard land bank in this release.",
    gallery: [
      U("photo-1500382017468-9049fed747ef"),
      U("photo-1486406146926-c627a92ad1ab"),
    ],
  },
};
